var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search_svg__Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".search_svg__cls-1{fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "search_svg__cls-1",
    d: "M12.5 5C8.36 5 5 8.36 5 12.5S8.36 20 12.5 20s7.5-3.36 7.5-7.5S16.64 5 12.5 5ZM3 12.5C3 7.25 7.25 3 12.5 3S22 7.25 22 12.5 17.75 22 12.5 22 3 17.75 3 12.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "search_svg__cls-1",
    d: "M18.29 18.29a.996.996 0 0 1 1.41 0l6 6a.996.996 0 1 1-1.41 1.41l-6-6a.996.996 0 0 1 0-1.41Z"
  })));
};

export default SvgSearch;